var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_138_108802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6099 18.3712L16.739 14.4986C19.6354 10.628 18.8456 5.14213 14.975 2.2457C11.1043 -0.650737 5.61851 0.139027 2.72208 4.00967C-0.174357 7.88032 0.615406 13.3661 4.48605 16.2626C7.59527 18.5892 11.8657 18.5892 14.975 16.2626L18.8476 20.1352C19.3342 20.6218 20.1233 20.6218 20.6099 20.1352C21.0965 19.6485 21.0965 18.8595 20.6099 18.3729L20.6099 18.3712ZM9.76279 15.5151C6.32275 15.5151 3.53407 12.7265 3.53407 9.28641C3.53407 5.84637 6.32275 3.05769 9.76279 3.05769C13.2028 3.05769 15.9915 5.84637 15.9915 9.28641C15.9879 12.7249 13.2013 15.5115 9.76279 15.5151Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_108802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.975586 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2f2b94c2e6edc7abec2e87977f16ff88.svg";
export { ForwardRef as ReactComponent };